import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { Stack, Button, TableRow, MenuItem, TableCell, IconButton, Typography } from '@mui/material';
// components
import Iconify from '../../../../components/iconify';
import MenuPopover from '../../../../components/menu-popover';
import ConfirmDialog from '../../../../components/confirm-dialog';
import ContainedButton from '../../../../components/actions/ContainedButton';
import { onGetFullname } from '../../../../utils/general';
//import Label from '../../../../components/label/Label';

// ----------------------------------------------------------------------

PatientTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onEditRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onSelectRow: PropTypes.func,
};

export default function PatientTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow }) {
  const { user_id, first_name, fathers_last_name, mothers_last_name, email, role } = row;

  const [openConfirm, setOpenConfirm] = useState(false);

  const [openPopover, setOpenPopover] = useState(null);

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const user_name = onGetFullname(row)

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell sx={{cursor:'pointer'}} padding="checkbox" onClick={onSelectRow}>
            <Typography variant="subtitle2" noWrap>
              {row?.id_user}
            </Typography>
        </TableCell>

        <TableCell sx={{cursor:'pointer'}} onClick={onSelectRow}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" noWrap>
              {user_name}
            </Typography>
          </Stack>
        </TableCell>

        <TableCell sx={{cursor:'pointer'}} align="left" onClick={onSelectRow}>{row?.main_role ?? '-'}</TableCell>

        <TableCell sx={{cursor:'pointer'}} align="left" onClick={onSelectRow}>
          {email}
        </TableCell>

        <TableCell sx={{cursor:'pointer'}} align="left" onClick={onSelectRow}>
        {row?.mobile_country_code ?? ''} {row?.mobile ?? '-'}
        </TableCell>



        {/*<TableCell align="left">
          <Label
            variant="soft"
            color={(status === 'banned' && 'error') || 'success'}
            sx={{ textTransform: 'capitalize' }}
          >
            {status}
          </Label>
  </TableCell>*/}

        <TableCell align="right">
          <IconButton color={openPopover ? 'inherit' : 'default'} onClick={handleOpenPopover}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <MenuPopover open={openPopover} onClose={handleClosePopover} arrow="right-top" sx={{ width: 140 }}>
        <MenuItem
          onClick={() => {
            handleOpenConfirm();
            handleClosePopover();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="eva:trash-2-outline" />
          Delete
        </MenuItem>

        <MenuItem
          onClick={() => {
            onEditRow();
            handleClosePopover();
          }}
        >
          <Iconify icon="eva:edit-fill" />
          Edit
        </MenuItem>
      </MenuPopover>

      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        title="Eliminar usuario"
        content="¿Está seguro de eliminar este usuario? Ya no podrá recuperarse en un futuro"
        action={
          <ContainedButton size='small' onClick={onDeleteRow}>
            Eliminar
          </ContainedButton>
        }
      />
    </>
  );
}
